import React from "react";
import {
  BG_JOB_STATUS,
  buttonNameConstants,
  EMPTY_STRING,
  shopifyConstants,
} from "../../../constants";

const StatusTag = (props) => {
  const { status } = props;
  const statusClasses = {
    [shopifyConstants.SHOPIFY_ORDER_STATUS.UNFULFILLED]:
      "order-status-unfulfilled",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.READY]: "order-status-ready",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.FULFILLED]: "order-status-fulfilled",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.CANCELLED]: "order-status-cancelled",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.PARTIAL_FULFILLED]:
      "order-status-partially-fulfilled",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.HOLD]: "order-status-hold",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.REFUNDED]: "order-status-refunded",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.PARTIAL_REFUNDED]:
      "order-status-partially-refunded",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.NEED_TRANSFER]:
      "order-status-need-transfer",
    [shopifyConstants.SHOPIFY_ORDER_STATUS.PENDING]: "order-status-pending",
    [buttonNameConstants.COMPLETED]: EMPTY_STRING,
    [buttonNameConstants.CANCELED]: "order-status-refunded",
    [buttonNameConstants.NOT_STARTED]: "order-status-refunded",
    [buttonNameConstants.IN_PROGRESS]: "order-status-unfulfilled",
    [BG_JOB_STATUS.COMPLETED]: "order-status-fulfilled",
    [BG_JOB_STATUS.FAILED]: "order-status-refunded",
    [BG_JOB_STATUS.IN_PROGRESS]: "order-status-unfulfilled",
    [BG_JOB_STATUS.PENDING]: "order-status-pending",
    [BG_JOB_STATUS.PAUSED]: "order-status-hold",
    [BG_JOB_STATUS.STARTING]: "order-status-unfulfilled",
  };

  return (
    <span
      className={`me-2 order-status-fulfilled text-truncate
                ${statusClasses[status] || EMPTY_STRING}
                `}
    >
      {status}
    </span>
  );
};

export default StatusTag;
